<template>
    <rkm-wizard
        ref="Wizard"
        @finish="$emit('finish')"
    >
        <rkm-wizard-tab
            title="Dados"
            icon="fas fa-hospital-symbol"
            :before-change="() => $refs.TabDados.validate()"
        >
            <TabDados
                ref="TabDados"
                :model="model"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            title="Dados administrativos"
            icon="fas fa-file-medical"
            :before-change="() => $refs.TabDadosAdministrativos.validate()"
        >
            <TabDadosAdministrativos
                ref="TabDadosAdministrativos"
                :form="form.dadosAdministrativos"
                :model="model"
            />
        </rkm-wizard-tab>

        <rkm-wizard-tab
            title="Local de atendimento"
            icon="fas fa-clinic-medical"
            :before-change="() => $refs.TabInfraestrutura.validate()"
        >
            <TabInfraestrutura
                ref="TabInfraestrutura"
                :termos-invalidos="form.termosInvalidos"
                :form="form.infraestruturas"
                :model="model"
            />
        </rkm-wizard-tab>
    </rkm-wizard>
</template>

<script>
// Components.
import TabDados from './tabs/Dados'
import TabDadosAdministrativos from './tabs/DadosAdministrativos'
import TabInfraestrutura from './tabs/Infraestrutura'

export default {
    components: {
        TabDados,
        TabDadosAdministrativos,
        TabInfraestrutura,
    },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    methods: {
        validate() {

            return this.$refs.TabInfraestrutura.validate()
        },
        goToDadosTab() {

            this.$refs.Wizard.changeTab(2, 0)
        }
    },
}
</script>